(function () {
  function initPrecioBaseFabrica(root) {
    if (!root || root.dataset.pbfInitialized === 'true') return;

    root.dataset.pbfInitialized = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pbf-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pbf-panel]'));

    function activateTab(id) {
      if (!id) return;

      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-pbf-tab') === id;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-pbf-panel') === id;

        panel.classList.toggle('is-active', isActive);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-pbf-tab'));
      });
    });

    activateTab('incluido');
  }

  function initAllPrecioBaseFabrica() {
    var roots = document.querySelectorAll('[data-pbf-root]');

    roots.forEach(function (root) {
      initPrecioBaseFabrica(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPrecioBaseFabrica);
  } else {
    initAllPrecioBaseFabrica();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pbf-root]');

    if (root) {
      root.dataset.pbfInitialized = 'false';
      initPrecioBaseFabrica(root);
    }
  });
})();